<template>
  <div class="agent-list">
    <div class="opreationBox">
      <div class="opreation-head clearfix">
        <div class="fl">
          推广用户：{{ AgentName }}下线列表
        </div>
        <div class="fr">
          <el-button
            @click="backAgent"
            type="primary"
          >
            返回推广列表
          </el-button>
        </div>
      </div>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column header-align="center" prop="name" label="用户名" />
        <el-table-column header-align="center" prop="mobilePhone" label="手机号" />
        <el-table-column header-align="center" prop="openId" label="openId" />
        <el-table-column header-align="center" prop="createTime" label="创建时间" />
        <el-table-column
          header-align="center"
          align="center"
          label="公众号状态"
        >
          <template slot-scope="scope">
            <span v-text="scope.row.isSubscribe?'已关注':'未关注'" :style="{color:scope.row.isSubscribe?'#67c23a':'#f56c6c'}"></span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="received" label="已领取总额(元)" />
        <el-table-column header-align="center" align="center" prop="unReceived" label="未领取余额(元)"/>
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="130"
        >
          <template slot-scope="scope">
            <el-button
              @click="lookQues(scope.row)"
              size="mini"
              plain
            >
              查看用户问卷
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      />
    </div>
    <questionnaire-dialog
      v-if="dialogDesVisible"
      :showDes.sync="dialogDesVisible"
      :desObj="desObj" />
  </div>
</template>

<script>
  import { getAgentChildrenPage as getList } from 'api/request'
  import { SetTableH } from '../../../utils/utils'
  import questionnaireDialog from "./questionnaireDialog";
  export default {
    name: 'subordinate',
    components: {
      questionnaireDialog
    },
    data() {
      return {
        loading: false,
        dataList: [],
        tableH: '250',
        pageObj: {
          total: 0,
          PageIndex: 1,
          PageSize: 10
        },
        partnerId: undefined,
        AgentName: undefined,
        desObj: null,
        dialogDesVisible: false
      }
    },
    methods: {
      initData() {
        this.partnerId = this.$route.query.id
        this.AgentName = this.$route.query.name
        this.getList(this.partnerId)
      },
      async getList(partnerId) {
        if (!partnerId) {
          return
        }
        const params = {
          PageIndex: this.pageObj.PageIndex,
          PageSize: this.pageObj.PageSize,
          partnerId: partnerId
        }
        this.loading = true
        let data = await getList(params)
        if (data) {
          this.dataList = data.rows
          this.pageObj.total = data.total
          this.loading = false
        }
      },
      handleSizeChange(val) {
        this.pageObj.PageSize = val
        this.getList(this.partnerId)
      },
      handleCurrentChange(val) {
        this.pageObj.PageIndex = val
        this.getList(this.partnerId)
      },
      lookQues(data) {
        this.desObj = data
        this.dialogDesVisible = true
      },
      backAgent() {
        this.$router.push({path: '/agent/list'})
      },
    },
    created() {
      this.initData()
    },
    mounted() {
      SetTableH(this)
    },
  }
</script>

<style scoped lang="scss">
  .agent-list{
    .pageBox {
      margin-top: 20px;
      text-align: right;
    }
    .tableBox{
      margin-top: 20px;
    }
    .opreation-head{
      height: 42px;
      line-height: 42px;
      .fl{
        float: left;
      }
      .fr{
        float: right;
      }
    }
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
  }
</style>
